class GrHeaderDrawer extends HTMLElement {
  connectedCallback() {
    if (this.#bound) return;
    this.#bound = true;

    this.#openButton = this.querySelector('[data-gr-drawer-open]');
    this.#closeButtons = this.querySelectorAll('[data-gr-drawer-close]');
    this.#panel = this.querySelector('[data-gr-drawer-panel]');

    this.#openButton?.addEventListener('click', this.#open);
    this.#closeButtons.forEach((button) => button.addEventListener('click', this.#close));
    document.addEventListener('keydown', this.#onKeyDown);
  }

  disconnectedCallback() {
    this.#openButton?.removeEventListener('click', this.#open);
    this.#closeButtons.forEach((button) => button.removeEventListener('click', this.#close));
    document.removeEventListener('keydown', this.#onKeyDown);
    this.#bound = false;
  }

  #bound = false;
  /** @type {HTMLElement | null} */
  #openButton = null;
  /** @type {NodeListOf<Element> | []} */
  #closeButtons = [];
  /** @type {HTMLElement | null} */
  #panel = null;

  #open = () => {
    this.setAttribute('open', '');
    this.#openButton?.setAttribute('aria-expanded', 'true');
    this.#panel?.setAttribute('aria-hidden', 'false');
    document.documentElement.setAttribute('scroll-lock', '');
    this.querySelector('[data-gr-drawer-close]')?.focus();
  };

  #close = (event) => {
    this.removeAttribute('open');
    this.#openButton?.setAttribute('aria-expanded', 'false');
    this.#panel?.setAttribute('aria-hidden', 'true');
    document.documentElement.removeAttribute('scroll-lock');

    const opensAnotherDialog = event?.currentTarget instanceof HTMLElement && event.currentTarget.hasAttribute('aria-haspopup');
    if (!opensAnotherDialog) {
      this.#openButton?.focus();
    }
  };

  /** @param {KeyboardEvent} event */
  #onKeyDown = (event) => {
    if (event.key !== 'Escape' || !this.hasAttribute('open')) return;
    event.preventDefault();
    this.#close();
  };
}

if (!customElements.get('gr-header-drawer')) {
  customElements.define('gr-header-drawer', GrHeaderDrawer);
}
